var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-alert',{attrs:{"value":true,"color":_vm.color,"type":_vm.type,"outline":""}},[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }